import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "types/api.types";
import type { WorkOrderExpenseCategory } from "../types/work-order.types";

export const getExpenseCategoriesList = async (params: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const { page = 1, limit = 20, search } = params;
  const response = await axiosClient.get<ApiResponse<ApiList<WorkOrderExpenseCategory[]>>>(
    "/expense-categories",
    { params: { page, limit, ...(search ? { search } : {}) } },
  );
  return response.data;
};

export const getExpenseCategoryOptions = async ({
  query,
  page = 1,
  limit = 20,
}: {
  query?: string;
  page?: number;
  limit?: number;
}): Promise<ApiResponse<ApiOptionList>> => {
  const res = await getExpenseCategoriesList({ page, limit, search: query?.trim() || undefined });
  const data = res.data;
  const rows = data?.rows ?? [];
  const totalPages = data?.totalPages ?? 1;
  return {
    success: res.success,
    message: res.message,
    data: {
      rows: rows.map((c) => ({ value: c.id, label: c.name })),
      totalPages,
      hasMore: page < totalPages,
    } as ApiOptionList,
  };
};